window.OutlookSync = {
	
	translations: {
		prefs				: Loc.g("Préférences Office 365 / Outlook Sync"),
		close				: Loc.g("Fermer"),
		save				: Loc.g("Enregistrer"),
		calendarSynchronize	: Loc.g("Le temps de chargement peut être important car les agendas se synchronisent. <br/>Veuillez patienter, ce message disparaitra automatiquement à la fin de la synchronisation"),
		titleSynchroKo		: Loc.g("Un problème est survenu"),
		messageSynchroKo	: Loc.g("Un problème est survenu lors de la synchronisation. Veuillez réessayer plus tard"),
		synchroContact		: Loc.g("Le temps de synchronisation des contacts peut être important en fonction du nombre de contacts à synchroniser. <br/>Veuillez patienter, ce message disparaitra automatiquement à la fin de la synchronisation"),
		reconnect			: Loc.g("Reconnexion Office 365 / Outlook Sync"),
		reinit				: Loc.g("Réinitialiser le module Office 365 / Outlook Sync"),
		confirmReinit		: Loc.g("Etes-vous sûr de vouloir réinitialiser le module ?"),
		titleConnect		: Loc.g("Connexion à Office 365 / Outlook"),
		redirOutlook		: Loc.g("Vous allez être redirigé vers la page d'authentification d'Office 365 / Outlook."),
		acceptRedirOutlook	: Loc.g("Vous devez accepter l'application pour synchroniser vos contacts & utiliser vos agendas Office 365 / Outlook depuis l'interface Sellsy."),
		synchronisation		: Loc.g("Synchronisation"),
		synchronisationMsg	: Loc.g("Synchronisation en cours"),
		updateCalendar		: Loc.g("Le temps de synchronisation des calendriers peut être important en fonction du nombre de calendrier à synchroniser. <br/>Veuillez patienter, ce message disparaitra automatiquement à la fin de la synchronisation"),
	},
	
	settings: {
		route : "/outlooksync/preferences",
		routeGetToken : "/outlooksync/getToken",
		routeDisconnect : "/outlooksync/disconnect",
		routeResetAccount : "/outlooksync/resetAccount",
		routeSynchroCalendar : "/outlooksync/synchrocalendar",
		routeSynchroContact : "/outlooksync/synchrocontact",
		routeSynchroEvent : "/outlooksync/synchroevent",
		routePrepareMigrate : "/outlooksync/preparemigrate",
		routeLoadCalendar : "/outlooksync/loadcalendar",
		routePrepareSync : "/outlooksync/preparesync",
	},
	
	loadPrefs : function(context){
		var self = this;
		options = {
			title	: self.translations.prefs,
			buttons	: [
				{
					text  : self.translations.close,
					'class'	: 'btn btn-default',
					click : function(){
						MyWindow.close();
					}
				},
				{
					text	: self.translations.save,
					'class'	: 'btn btn-primary',
					click	: function(){
						$('#osyncPrefsForm').closest('form').submit();
					}
				}
			],
			width: 500,
			callback : function(){
				OutlookSync.preparePrefsForm();
			}
		};
		
		MyWindow.load(self.settings.route, {
            context: context
        }, options, true, undefined, null, 'get', false);
	},
	
	forceSynchroCalendar : function() {
		var self = this;
		
		MyWindow.wait(undefined, self.translations.updateCalendar);
		
		MyFacture.post(
			self.settings.routeSynchroCalendar, {}, function(data){
				if (data.status == 'ko') {
					Push.error(data.message);
				}
				MyWindow.awake();
			}, 
			"json",
			false,
			false
		);
	},
	
	preparePrefsForm : function(){
		var self = this;
		
		var options = {
			success:function(data){
				OutlookSync.recordCallback(data);
				MyWindow.close();
			}, 
			dataType:"json"
		};
		
		MyForm.prepare("osyncPrefsForm", self.settings.route, options, true, true, true);
		MyFacture.customForm();
	},
	
	recordCallback : function(data){
		MyWindow.awake();
	},

	connect : function() {
		var self = this;

        let routeGetToken = self.settings.routeGetToken;
        
        switch ($('#oprefs_context').val()) {
            case 'scheduler':
                routeGetToken += '?successUrl=' + window.sellsyapp.$router.resolve({ name: 'onboarding.scheduler' }).href;
                break;
        }
		
        MyFacture.post(routeGetToken, null, function(data) {
			if(data !== null) {
				var options = {
					resizable	: false,
					noclose		: true,
					title		: self.translations.titleConnect,
					buttons		: [
						{
							text : Loc.g("Annuler"),
							'class': 'btn btn-default',
							click: function(){
								MyFacture.post(self.settings.routeDisconnect, null, null, "json", false, false);
								$(this).dialog("close");
							}
						},
						{
							text : Loc.g("Valider"),
							'class': 'btn btn-primary',
							click: function(){
								window.location = data.authUrl;
							},
						}
					]
				};
				MyWindow.alert(self.translations.redirOutlook + "<br/><br /> " + self.translations.acceptRedirOutlook, options);
			}
		}, "json", false, false);
		
		$(document).keyup(function(e) {
			if (e.keyCode == 27) { 
				MyFacture.post(self.settings.routeDisconnect, null, null, "json", false, false);
			}
		});
	},

	disconnect : function() {
		var self   = this;
		MyFacture.post(self.settings.routeDisconnect, null, function(data) {
            OutlookSync.loadPrefs($('#oprefs_context').val());
		}, "json", false, false);
	},

	checkDisplayAgenda : function () {
		if($('input[name=oprefs_syncagenda]').is(':checked')){
			$("#fieldsetAgenda").show();
		} else {
			$("#fieldsetAgenda").hide();
		}
	},
	
	migrateNow : function (origin) {
		var self   = this;
        var origin = (origin != undefined) ? origin : 'agenda';
		
		MyWindow.getLoader();

		MyFacture.post(
			self.settings.routePrepareMigrate,
			{}, 
			function(data){

				if(origin === "agenda") {
					$("#layout-outlooksync").html(data);
				}else {
					$("#content_agenda").html(data);
				}
				OutlookSync.prepareMigrate(origin);
			},
			'',
			false,
			false
		);
	},
	
	prepareMigrate : function(origin) {
		var self = this;
		
		MyFacture.post(
			self.settings.routeLoadCalendar,
			{},
			function(data){
				if(data.result === 'ok'){
					OutlookSync.prepareSync(origin);
				}
			},
			'json',
			false,
			false
		);
	},
	
	prepareSync : function(origin) {
		var self   = this;
        var origin = (origin != undefined) ? origin : 'agenda';
		
		MyFacture.post(
			self.settings.routePrepareSync,
			{
				origin	: origin
			}, function(data){
				if(origin === "agenda") {
					$("#layout-outlooksync").html(data);
				}else {
					$("#content_agenda").html(data);
				}
			},
			'',
			false,
			false
		);
	},
	
	migrate : function(origin) {
		var self   = this;
        var origin = (origin != undefined) ? origin : 'agenda';
		MyFacture.startWait();
		
		MyFacture.post(self.settings.routeSynchroEvent, 
			{
				nextEvent	: $('#nextEvent').is(':checked'),
				pastEvent	: $('#pastEvent').is(':checked'),
				calendarId	: $('#aevent_calendar').val()
			}, 
			function(data){
				
				if(data.result === "ok"){
					if(origin === "agenda") {
						Utils.relocate("/?_f=agenda");
					} else {
						Utils.reload();
					}
				} else {
					var options = {
						resizable	: false,
						noclose		: true,
						title		: self.translations.titleSynchroKo,
						buttons		: [
							{
								text : Loc.g("Ok"),
								click: function(){
									$(this).dialog("close");
								}
							}
						]
					};
					MyFacture.stopWait();
					MyWindow.alert(self.translations.messageSynchroKo, options);
				}
			}, 
			"json",
			false,
			false
		);
	},
	
	confirmResetAccount: function() {
		var self = this;
		var options = {
			type: "warning",
			resizable	: false,
			noclose		: true,
			title		: self.translations.reinit,
			buttons		: [
				{
					text : Loc.g("Oui"),
					click: function(){
						OutlookSync.resetAccount();
					}
				},
				{
					text : Loc.g("Non"),
					click: function(){
						$(this).dialog("close");
					}
				}
			]
		};
		MyWindow.alert(self.translations.confirmReinit, options);
	},
	
	resetAccount: function() {
		var self = this;
		$('#buttonResetOutlookSync').css('pointer-events', 'none').css('cursor', 'default');
		$('#loader_resetOutlookSync').css('display', 'inline');
		MyFacture.post(self.settings.routeResetAccount, {}, function(){
			$('#loader_resetOutlookSync').css('display', 'none');
			Utils.relocate('?_f=store');
		}, 'json', false, false);
	},
		
	//Gestion des contacts
	checkDisplayContact : function () {
		if($('input[name=oprefs_synccontacts]').is(':checked')){
			$("#fieldsetContact").show();
		} else {
			$("#fieldsetContact").hide();
		}
	},
	
	forceSynchroContact : function() {
		var self = this;
		
		MyWindow.wait(undefined, self.translations.synchroContact);
		MyFacture.post(
			self.settings.routeSynchroContact, 
			$('#osyncPrefsForm').closest('form').serialize(),
			function(data){
				Push.success(data.message, self.translations.synchronisation);
				MyWindow.awake();
				MyWindow.close();
			}, 
			"json",
			false,
			false
		);
	},

	migrateAppLater : function () {
		var self = this;
		MyFacture.post(self.settings.routeDisconnect,
			{}, 
			function(){
				Utils.relocate('/?_f=agenda');
			},
			'json',
			false,
			false
		);
	}
};